"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MenuIcon = styled_components_1.default.img `
  margin-right: 5px;
  vertical-align: sub;
`;
//# sourceMappingURL=main-menu-icon.js.map